const Aggression = require("../../entities/Aggression");
const { Age }  = require("../Constants");
const AggessionNames = require("../Names/AggressionNames");

class Annex extends Aggression {
    constructor() {
        super(
            Age.Age2,
            AggessionNames.Annex,
            2,
            "Take one colony from a rival. You gain (and they lose) its permanent bonuses, but ignore any one-time gains.",
            {
                //effect
            }
        )
    }
}

module.exports = Annex;